import { render, staticRenderFns } from "./enterInfo.vue?vue&type=template&id=67b3d5cb&scoped=true"
import script from "./enterInfo.vue?vue&type=script&lang=js"
export * from "./enterInfo.vue?vue&type=script&lang=js"
import style0 from "./enterInfo.vue?vue&type=style&index=0&id=67b3d5cb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b3d5cb",
  null
  
)

export default component.exports